<template lang="pug">
section
  s-page-title(title='MetaPages')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(xs12)
            s-sites-picker(
              :value='dataFilter.site_id'
              :returnObject='false'
              @change='setSiteId'
              label='Выберите сайт'
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.front_url }}
          td
            div {{ props.item.meta_title }}
            v-chip(
              v-for="site in forSites(props.item.site_ids)"
              :color="props.item.published==1 ? site.color : 'gray'"
              :key="site.name"
              text-color="white"
              small
            ) {{site.name}}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='seo/corppages'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'URL страницы',
        align: 'left',
        sortable: true,
        value: 'front_url'
      },
      {
        text: 'Title страницы',
        align: 'left',
        value: 'meta_title',
        width: '0%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'seo/corppages',
      itemValue: 'id',
      itemText: 'front_url'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    forSites(ids) {
      if (!ids) return {}
      return ids.split(/,/).map(site_id => {
        const site = this.sitesById(site_id)
        if (!site) return {}
        return {
          color: site.color,
          name: site.name
        }
      })
    },

    setSiteId(site_id = null) {
      this.setDataFilter({ site_id })
      this.fetch()
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.MetaPages.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('seo/metaPages', ['fetchList', 'destroy']),
    ...mapMutations('seo/metaPages', ['setDataFilter'])
  },

  computed: {
    ...mapState('seo/metaPages', ['total', 'dataFilter']),
    ...mapGetters('seo/metaPages', ['list', 'isLoading']),
    ...mapGetters({ sitesById: 'dictionary/sites/byId' })
  }
}
</script>
